// 注册自定义组件渲染器
import { registerRendererByType } from '@/utils/amis-widget/index.esm.js'
import InfoComponent from './info-component'

registerRendererByType(InfoComponent, {
  type: 'info-component',
  usage: 'renderer',
  weight: 99,
  framework: 'vue'
})
